<template>
    <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">Histórico de Atendimentos e Eventos</h3>
            <div class="mt-5 border-t border-gray-200">
                <ul v-if="!loading" role="list" class="-mb-8 pt-4">
                    <li v-for="(item, index) in historico" :key="index">
                        <div class="relative pb-8">
                            <span v-if="index !== historico.length - 1" class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                            <div class="relative flex space-x-3">
                                <div>
                                    <span class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                                          :class="{'bg-blue-500': item.tipo === 'visita', 'bg-purple-500': item.tipo === 'Revisão/Enquadramento', 'bg-green-500': item.tipo !== 'visita' && item.tipo !== 'Revisão/Enquadramento'}">
                                        <svg v-if="item.tipo === 'Revisão/Enquadramento'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <svg v-else class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </span>
                                </div>
                                <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                                    <div>
                                        <p class="text-sm text-gray-500"><span class="font-bold text-gray-700">{{ item.tipo === 'visita' ? 'Atendimento' : item.tipo }}</span> - {{ item.descricao }}</p>
                                    </div>
                                    <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                        <time>{{ item.dateToSort.toLocaleDateString('pt-BR') }}</time>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-if="historico.length === 0" class="text-gray-500 text-sm">Nenhum evento registrado ainda.</li>
                </ul>
                <div v-else class="text-center p-6 text-gray-500">Buscando histórico...</div>
            </div>
        </div>
    </div>
</template>

<script>
import ClientPortalRepository from '@/services/ClientPortalRepository.vue';

export default {
    name: 'ClienteHistoricoView',
    data() {
        return {
            loading: true,
            historico: [],
            service: new ClientPortalRepository()
        }
    },
    async mounted() {
        await this.carregarHistorico();
    },
    methods: {
        async carregarHistorico() {
            this.loading = true;
            try {
                const res = await this.service.getHistorico();
                const mapVisitas = res.data.visitas.map(v => ({...v, tipo: 'visita', descricao: 'Registro de Atendimento/Visita. Status: ' + v.status_visita, dateToSort: new Date(v.created_at)}));
                const mapTimeline = res.data.timeline.map(t => ({...t, tipo: t.tipo, descricao: t.descricao, dateToSort: new Date(t.created_at)}));
                const mapEventos = (res.data.eventos || []).map(e => ({
                    ...e,
                    tipo: 'Revisão/Enquadramento',
                    descricao: `Fator Ajuste IPCA/Reenquadramento. ${e.aplicou_ipca ? '(IPCA Aplicado).' : ''} Plano: ${e.plano && e.plano.nome ? e.plano.nome : '-'} | Apólice N. ${e.apolice && e.apolice.numero ? e.apolice.numero : '-'}`,
                    dateToSort: new Date(e.created_at)
                }));
                
                let all = [...mapVisitas, ...mapTimeline, ...mapEventos];
                all.sort((a,b) => b.dateToSort - a.dateToSort);
                
                this.historico = all;
            } catch (error) {
                console.error("Erro ao puxar dados", error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
